AFRAME.registerComponent('gameover', {
  schema: {
    isGameOver: {default: false}
  },

  init: function () {
    this.beatContainer = document.getElementById('beatContainer');
    this.gameOverEls = document.querySelectorAll('[animation__gameover]');
  },

  update: function (oldData) {
    var data = this.data;
    if (!oldData.isGameOver && this.data.isGameOver) {
      this.triggerAnimations();
      this.countDown = 1;
    }
    if (oldData.isGameOver && !this.data.isGameOver) {
      this.reset();
    }
  },

  tick: function (time, delta) {
    if (!this.data.isGameOver) { return; }
    if (this.countDown >= 0) {
      this.beatContainer.object3D.position.z = -Math.pow(1 - this.countDown, 2) * 1.5;
      this.countDown -= delta / 1000;
    }
  },

  reset: function () {
    this.beatContainer.object3D.position.z = 0;
    this.el.sceneEl.setAttribute('stage-colors', 'color', 'blue');
  },

  triggerAnimations: function () {
    for (let i = 0; i < this.gameOverEls.length; i++) {
      this.gameOverEls[i].emit('gameover', null, false);
    }
    this.el.emit('textglowoff', null, false);
    this.el.emit('bgcolorgameover', null, false);
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['gameover',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
